import { Col, Form, Input, Row } from "antd";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import InputCpf from "../../../../../components/input-cpf";
import InputRazaoSocial from "../../../../../components/input-razao-social";
import MiniForm from "../../../../../components/mini-form";
import SelectBoolean from "../../../../../components/select-boolean";
import InputNumber from "../../../../../components/input-number";

export default function EmpresaSocioForm4({
  disabled,
  form,
  loading,
  onFinish,
  title,
}) {
  const { t } = useTranslation();

  return (
    <MiniForm
      form={form}
      loading={loading}
      onFinish={onFinish}
      initialValues={{
        incapacitado: false,
      }}
    >
      {title}
      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <Form.Item name="documento" label={t("CPF")}>
            <InputCpf disabled={disabled} />
          </Form.Item>
        </Col>
        <Col flex="400px">
          <Form.Item name="nome" label={t("Nome")}>
            <InputRazaoSocial disabled={disabled} />
          </Form.Item>
        </Col>
        <Col flex="200px">
          <Form.Item name="exterior" label={t("Domicílio Estrangeiro")}>
            <SelectBoolean disabled={disabled} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="600px"></Col>
        <Col flex="200px">
          <Form.Item name="incapacitado" label={t("Menor Incapacitado")}>
            <SelectBoolean disabled={disabled} value={false} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px">
          <Form.Item name="obs" label={t("Observação")}>
            <Input.TextArea autoSize disabled={disabled} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="capitalQuantidade" noStyle initialValue={0} />
      <Form.Item name="capitalQuantidade2" noStyle initialValue={0} />
      <Form.Item name="capitalValorUnitario" noStyle initialValue={0} />
    </MiniForm>
  );
}

EmpresaSocioForm4.propTypes = {
  disabled: PropTypes.bool,
  form: PropTypes.object,
  loading: PropTypes.bool,
  onFinish: PropTypes.func,
  title: PropTypes.node,
};
